import { customFetch } from "@/client/custom-fetch";

import type {
  TMetaGraphMessageTemplatesResponse,
  TMetaGraphPhoneNumbersResponse,
  TWhatsappMetaConfig,
  TWhatsappMetaConfigCreatePayload,
  TWhatsappMetaConfigUpdatePayload,
} from "./whatsapp-meta-config.types";

const BASE = "/whatsapp-meta-configs";

function orgScopedInit(
  organizationScopeId: string | undefined,
  init: RequestInit = {}
): RequestInit {
  if (!organizationScopeId?.trim()) {
    return init;
  }
  const h = new Headers(init.headers);
  h.set("x-organization-id", organizationScopeId.trim());
  return { ...init, headers: Object.fromEntries(h.entries()) };
}

export const whatsappMetaConfigApi = {
  /** @param organizationScopeId opcional — use na navegação por cliente (ex.: campanhas) para alinhar ao tenant */
  list: (organizationScopeId?: string): Promise<TWhatsappMetaConfig[]> => {
    return customFetch<TWhatsappMetaConfig[]>(
      BASE,
      orgScopedInit(organizationScopeId, { method: "GET" })
    );
  },

  create: (
    body: TWhatsappMetaConfigCreatePayload
  ): Promise<TWhatsappMetaConfig> => {
    return customFetch<TWhatsappMetaConfig>(BASE, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  update: (
    id: string,
    body: TWhatsappMetaConfigUpdatePayload
  ): Promise<TWhatsappMetaConfig> => {
    return customFetch<TWhatsappMetaConfig>(`${BASE}/${id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },

  remove: (id: string): Promise<void> => {
    return customFetch<void>(`${BASE}/${id}`, { method: "DELETE" });
  },

  phoneNumbers: (
    configId: string,
    organizationScopeId?: string
  ): Promise<TMetaGraphPhoneNumbersResponse> => {
    return customFetch<TMetaGraphPhoneNumbersResponse>(
      `${BASE}/${configId}/phone-numbers`,
      orgScopedInit(organizationScopeId, { method: "GET" })
    );
  },

  messageTemplates: (
    configId: string,
    opts?: { after?: string; limit?: number; organizationScopeId?: string }
  ): Promise<TMetaGraphMessageTemplatesResponse> => {
    const params = new URLSearchParams();
    if (opts?.after) {
      params.set("after", opts.after);
    }
    if (opts?.limit != null) {
      params.set("limit", String(opts.limit));
    }
    const q = params.toString();
    const organizationScopeId = opts?.organizationScopeId;
    return customFetch<TMetaGraphMessageTemplatesResponse>(
      `${BASE}/${configId}/message-templates${q ? `?${q}` : ""}`,
      orgScopedInit(organizationScopeId, { method: "GET" })
    );
  },
};
